/*HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import logo from '../src/img/logo.svg';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { esES } from "@mui/x-date-pickers/locales";
import es from "date-fns/locale/es";
import { AllSystemProvider } from "./context/System/AllSystemProvider";
import { AllToolsProvider } from './context/Tools/AllToolsProvider';
import { AllFormsProyectProvider } from './context/FormsProyect/AllFormsProyectProvider'
import HcorzPage from "./components/layout/HcorzPage";

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        // localeText={
        //   esES.components.MuiLocalizationProvider.defaultProps.localeText
        // }
        adapterLocale="es"
      >
        <AllSystemProvider>
          <AllToolsProvider>
            <AllFormsProyectProvider>
              <HcorzPage />
            </AllFormsProyectProvider>
          </AllToolsProvider>
        </AllSystemProvider>
      </LocalizationProvider>
    </BrowserRouter>
  );
}

export default App;
